import axios from "axios";
import { BASE_URL } from "config";

const client = axios.create({
  baseURL: BASE_URL, 
  timeout: 0,
  headers: {
    "Content-Type": "application/json",
    // "api-key": APIKEY,
  },
});

// client.interceptors.response.use(
//   (response) => response.data,
//   (error) => {
//     if (error.response) {
//       return Promise.reject(error.response.data);
//     } else {
//       return Promise.reject(error);
//     }
//   }
// );

const setAuthorization = (token) => {
  console.log("setAuthorization", token);
  client.defaults.headers.token = token;
};

const clearAuthorization = () => {
  delete client.defaults.headers.common.authorization;
};

export const httpClient = { ...client, setAuthorization, clearAuthorization };
